import { useState } from "react";
import { Link } from "react-router-dom";
import Table from "react-bootstrap/Table";
import { RiEyeLine } from "react-icons/ri";
import { dateFormatter } from "../../utils/helper";

const Pending = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalItems = data.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, totalItems);

  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const handleNextPage = () => {
    if (currentPage < Math.ceil(data.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => { if (currentPage > 1) { setCurrentPage(currentPage - 1) } };
  const getSerialNo = (index) => { return indexOfFirstItem + index + 1 };
  const getPaginationText = () => { return totalItems === 0 ? '' : `${indexOfFirstItem + 1}-${indexOfLastItem} of ${totalItems} items` };

  return (
    <>
      <div className="comm-table pt-0">
        <Table>
          <thead>
            <tr className="head-class-td">
              <th>Sr. no.</th>
              <th>Name</th>
              <th>Email Address</th>
              <th>Date</th>
              <th>Condition</th>
              <th width="10%">Action</th>
            </tr>
          </thead>
          <tbody>
            {currentItems && currentItems.length > 0 ?
              (
                currentItems.map((data, index) => {
                  return (
                    <tr key={index}>
                      <td>{getSerialNo(index)}</td>
                      <td className="id_txt">{data?.user_id?.full_name}</td>
                      <td>{data?.user_id?.email}</td>
                      <td>{dateFormatter(data?.updatedAt, true)}</td>
                      <td>{data?.condition || 'Not Specified'} </td>
                      <td>
                        <Link className="table-view-btn" to="/consultation-view" state={{ data: data }}>
                          <RiEyeLine />
                        </Link>
                      </td>
                    </tr>
                  )

                }))
              :
              (<tr><td colSpan="6" className="text-center py-3">No records found</td></tr>)
            }

          </tbody>
        </Table>
      </div>


      {totalItems > 10 && (
        <div className="d-flex table_bottom_row">
          <h4 className="page_count_txt">{getPaginationText()}</h4>
          <div className="d-flex btn_grp">
            <button className="table_bott_btn" onClick={handlePrevPage} disabled={currentPage === 1}>Previous</button>
            <button className="table_bott_btn" onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
          </div>
        </div>
      )}
    </>
  )
}

export default Pending
